import { createContext, useContext } from 'react'

interface CompensationsRefreshContextValue {
  refreshCompensations: () => void
}

export const CompensationsRefreshContext = createContext<CompensationsRefreshContextValue | null>(
  null
)

export const useCompensationsRefresh = () => {
  const context = useContext(CompensationsRefreshContext)
  if (!context) {
    throw new Error(
      'useCompensationsRefresh must be used within a CompensationsRefreshContext.Provider'
    )
  }
  return context
}
